export enum HttpLoadMode {
  GET = 'get',
  POST = 'post',
  DELETE = 'delete',
  HEAD = 'head',
  PUT = 'jsonp',
}
